import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    background: #f1f3f8;
`;

export const PartnerWrapper = styled.div`
    padding: 60px 140px;
    max-width: 1440px;
    margin: auto;
    @media screen and (max-width: 780px) {
        padding: 40px 20px;
    }
`;

export const PartnerTitle = styled.div`
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 30px;
    line-height: 36px;
    text-align: center;
    color: #434f5a;
    margin-bottom: 40px;

    @media screen and (max-width: 780px) {
        font-size: 26px;
        line-height: 31px;
        letter-spacing: 0.02em;
    }
`;

export const PartnersContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    row-gap: 40px;
    column-gap: 120px;
    flex-wrap: wrap;
    margin: 0 80px;
    margin-top: 70px;
    margin-bottom: 20px;

    @media screen and (max-width: 780px) {
        column-gap: 100px;
        margin: 0 100px;
    }

    @media screen and (max-width: 480px) {
        column-gap: 40px;
        margin: 0 20px;
    }
`;

export const PartnerDiv = styled.div`
    display: flex;
    justify-content: center;
    align-self: center;
    padding: 20px;
`;
